import { api } from './client';

// Attendance Tracker (coach sidebar "Attendance" tab): per-student attendance
// summary for a Balagruha + date range.
// GET /api/v2/coach/attendance-tracker/summary -> { success, data: { totalClasses, students: [...] } }
export const getAttendanceSummary = async ({ balagruhaId, startDate, endDate }) => {
  const response = await api.get('/api/v2/coach/attendance-tracker/summary', {
    params: { balagruhaId, startDate, endDate },
  });
  return response.data;
};

// Attendance Tracker: upsert one student's attendance record for one day.
// POST /api/v2/coach/attendance-tracker/entries -> { success, data: entry }
export const saveAttendanceEntry = async ({ balagruhaId, studentId, date, status, homework, remark, improvementNeeded }) => {
  const response = await api.post('/api/v2/coach/attendance-tracker/entries', {
    balagruhaId,
    studentId,
    date,
    status,
    homework,
    remark,
    improvementNeeded,
  });
  return response.data;
};

// Attendance Tracker: delete one student's attendance record for one day.
// DELETE /api/v2/coach/attendance-tracker/entries -> { success }
export const deleteAttendanceEntry = async ({ studentId, date }) => {
  const response = await api.delete('/api/v2/coach/attendance-tracker/entries', {
    data: { studentId, date },
  });
  return response.data;
};
